import { Pill } from '@iwoca/orion';
import { PERMISSION_LABELS } from './PermissionsCell.helpers';
import styles from './PermissionsCell.module.css';
import { TPermissions } from './PermissionsCell.types';

type TProps = { permissions: TPermissions };

export const PermissionsCell = ({ permissions }: TProps) => {
  return (
    <div className={styles.cell}>
      {PERMISSION_LABELS.filter(({ key }) => permissions[key]).map(
        ({ key, label }) => (
          <Pill key={key} variant="london" size="small">
            {label}
          </Pill>
        ),
      )}
    </div>
  );
};
